import {EventEmitter, Injectable} from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentoRecibidoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  guardarDocumentoCompra(inputParams, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: documento_recibidoDTOInputType) {
          documento_recibido {
            recibirDocumentoCompra(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                cabecera{
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  bodega_codigo
                  id_doc
                  id_xml
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_recibido.recibirDocumentoCompra
        callback({ mensajes, respuesta })
      }
    );
  }
}
